__turbopack_context__.v({
  "banner": "DebugBanner-module-scss-module__5ahjea__banner",
});
